import {useCallback, useEffect, useRef, useState} from "react";

export const useSpeechRecognition = (lang = "it-IT", interimResults = false, maxAlternatives = 1) => {
  const recognitionRef = useRef(null);
  const [isSupported, setIsSupported] = useState(true);
  const [transcript, setTranscript] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      setIsSupported(false);
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = lang;
    recognition.interimResults = interimResults;
    recognition.maxAlternatives = maxAlternatives;

    recognition.onresult = event => {
      const text = event.results[0][0].transcript;
      setTranscript(text);
    };

    recognition.onerror = event => {
      setError(event.error);
      setIsListening(false);
      console.error(event.error);
    };

    recognition.onstart = () => {
      setTranscript("");
      setError(null);
      setIsListening(true);
    };

    recognition.onend = () => {
      setIsListening(false);
    };

    recognitionRef.current = recognition;
  }, [lang, interimResults, maxAlternatives]);

  const start = useCallback(() => {
    if (recognitionRef.current) {
      recognitionRef.current.start();
    }
  }, []);

  const stop = useCallback(() => {
    if (recognitionRef.current) {
      recognitionRef.current.stop();
    }
  }, []);

  return {
    transcript,
    error,
    isSupported,
    isListening,
    start,
    stop
  };
};
